import Vue from 'vue'
import Base from '@/layouts/base'
import router from './router'
import store from './store'
import vuetify from './plugins/vuetify'


// --------------
// vue-chart-3 setup
// --------------

import { Chart, registerables } from "chart.js";
import VComp from "@vue/composition-api"
Chart.register(...registerables)
Vue.use(VComp)

// --------------
// VueMask setup
// --------------

import VueMask from 'v-mask'
Vue.use(VueMask)

Vue.config.productionTip = false

var oldLog = console.log;
console.log = function( ...items ) {
  // Call native method first  
  oldLog.apply(this, items)
  store.commit('console/APPEND', items)
}

// --------------
// Leaflet setup
// --------------

import '@/assets/global.css'
import 'leaflet/dist/leaflet.css'

// fix webpack issues with leaflet
import {  Icon } from 'leaflet'

delete Icon.Default.prototype._getIconUrl
Icon.Default.mergeOptions({
  iconRetinaUrl: require('leaflet/dist/images/marker-icon-2x.png'),
  iconUrl: require('leaflet/dist/images/marker-icon.png'),
  shadowUrl: require('leaflet/dist/images/marker-shadow.png'),
})

// --------------
// vue-signature-pad
// --------------

import VueSignaturePad from 'vue-signature-pad'

import './registerServiceWorker'
Vue.use(VueSignaturePad)

// Setup formatting library
import formatters from '@/lib/formatters'
Vue.use((app) => {
  app.prototype.$formatters = formatters
})

new Vue({
  router,
  store,
  vuetify,
  render: h => h(Base)
}).$mount('#app')
